{
  "account-not-existed-dialog": {
    "buttons": {
      "cancel": "Abbrechen",
      "sign-up": "Registrieren"
    },
    "text": {
      "hint": "Wenn Sie neu bei uns sind, erstellen Sie bitte zuerst Ihr Konto!",
      "not-found-account-with-email": "Es gibt kein Konto mit dieser E-Mail {{ email }}",
      "not-found-account-with-phone-nr": "Es gibt kein Konto mit dieser Telefonnummer {{ phoneNr }}",
      "title": "Konto existiert nicht"
    }
  }
}
